// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WishListModalForm-displayFlex-MtisF {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    width: 100%;
}

.WishListModalForm-listHeight-IV12U {
    max-height: 40vh;
    overflow-y: auto;
    margin: 0 -10px;
    padding: 0 10px;
}

.WishListModalForm-imgContainer-GMUfM {
    width: 100%;
    max-width: 54px;
    height: 54px;
    background-position: 50% 50%;
    background-size: cover;
    background-repeat: no-repeat;
    padding-top: 14%;
    background-color: var(--common-gray-bg-color);
    border-radius: 6px;
}

.WishListModalForm-defaultImage-NkKvz {
    background-color: var(--common-gray-bg-color);
    background-size: 30px;
}

.WishListModalForm-heartBtn-fzEeG,
.WishListModalForm-heartBtn-fzEeG:hover,
.WishListModalForm-heartBtn-fzEeG:active,
.WishListModalForm-heartBtn-fzEeG:focus {
    background-color: transparent !important;
    -webkit-box-shadow: unset !important;
            box-shadow: unset !important;
    border: unset !important;
    padding: 0 !important;
    color: var(--common-link-color) !important;
    cursor: pointer;
}

.WishListModalForm-namePadding-SwO3b {
    padding: 0 18px;
}

.WishListModalForm-marginBottom-sqJsW {
    margin-bottom: 18px;
}

.WishListModalForm-marginBottom-sqJsW:last-child {
    margin-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/WishListModalForm/WishListModalForm.css"],"names":[],"mappings":"AAAA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,4BAA4B;IAC5B,sBAAsB;IACtB,4BAA4B;IAC5B,gBAAgB;IAChB,6CAA6C;IAC7C,kBAAkB;AACtB;;AAEA;IACI,6CAA6C;IAC7C,qBAAqB;AACzB;;AAEA;;;;IAII,wCAAwC;IACxC,oCAA4B;YAA5B,4BAA4B;IAC5B,wBAAwB;IACxB,qBAAqB;IACrB,0CAA0C;IAC1C,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".displayFlex {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n}\n\n.listHeight {\n    max-height: 40vh;\n    overflow-y: auto;\n    margin: 0 -10px;\n    padding: 0 10px;\n}\n\n.imgContainer {\n    width: 100%;\n    max-width: 54px;\n    height: 54px;\n    background-position: 50% 50%;\n    background-size: cover;\n    background-repeat: no-repeat;\n    padding-top: 14%;\n    background-color: var(--common-gray-bg-color);\n    border-radius: 6px;\n}\n\n.defaultImage {\n    background-color: var(--common-gray-bg-color);\n    background-size: 30px;\n}\n\n.heartBtn,\n.heartBtn:hover,\n.heartBtn:active,\n.heartBtn:focus {\n    background-color: transparent !important;\n    box-shadow: unset !important;\n    border: unset !important;\n    padding: 0 !important;\n    color: var(--common-link-color) !important;\n    cursor: pointer;\n}\n\n.namePadding {\n    padding: 0 18px;\n}\n\n.marginBottom {\n    margin-bottom: 18px;\n}\n\n.marginBottom:last-child {\n    margin-bottom: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"displayFlex": `WishListModalForm-displayFlex-MtisF`,
	"listHeight": `WishListModalForm-listHeight-IV12U`,
	"imgContainer": `WishListModalForm-imgContainer-GMUfM`,
	"defaultImage": `WishListModalForm-defaultImage-NkKvz`,
	"heartBtn": `WishListModalForm-heartBtn-fzEeG`,
	"namePadding": `WishListModalForm-namePadding-SwO3b`,
	"marginBottom": `WishListModalForm-marginBottom-sqJsW`
};
module.exports = ___CSS_LOADER_EXPORT___;
